import { render, staticRenderFns } from "./StarsDiscoveryMessage.vue?vue&type=template&id=6f27cf7d&scoped=true&"
import script from "./StarsDiscoveryMessage.vue?vue&type=script&lang=js&"
export * from "./StarsDiscoveryMessage.vue?vue&type=script&lang=js&"
import style0 from "./StarsDiscoveryMessage.vue?vue&type=style&index=0&id=6f27cf7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f27cf7d",
  null
  
)

export default component.exports